import ButtonBase from '@material-ui/core/ButtonBase';
import { navigate } from '@reach/router';
import IconLimit from 'assets/svg/limit-row.inline.svg';
import IconSelect from 'assets/svg/selekt-row.inline.svg';
import LinkItem from 'components/Atoms/LinkItem';
import { routes } from 'constants/routes';
import React from 'react';
import tw, { styled } from 'twin.macro';

const Button = styled(ButtonBase)`
	&& {
		${tw`flex flex-col items-start justify-center py-10 px-20`};
	}
`;

export default function OurOffers() {
	return (
		<div className='flex flex-col items-center justify-center border-t border-b border-solid border-grey-D bg-grey-F'>
			<Button onClick={() => navigate(routes.SELECT_OFFER)}>
				<IconSelect width='13.5rem' height='3.8rem' />

				<div className='text-left py-10'>
					<p className='contents font-semibold'>Faktoring zagraniczny</p> - to produkt przeznaczony dla firm sprzedających głównie za granicę. Jeżeli dostarczasz towary lub wykonujesz usługi dla odbiorców zlokalizowanych poza granicami Polski, to usługa Selekt jest właśnie dla Ciebie. Dzięki niej otrzymasz środki od Smart Faktor natychmiast po zgłoszeniu wierzytelności do wykupu i nie czekając na termin płatnościod klienta. Na Twoją prośbę możemy ustalić rozliczenia w tej samej walucie, w której wystawiasz faktury.
				</div>
				<div className='w-full flex items-center justify-end'><LinkItem to={routes.SELECT_OFFER} /></div>
			</Button>
			<Button onClick={() => navigate(routes.LIMIT_OFFER)} tw='py-05'>
				<IconLimit width='12rem' height='3.5rem' />

				<div className='text-left py-10'>
					<p className='contents font-semibold'>Faktoring krajowy</p> - Charakteryzuje się tym, że odbiorcami i dostawcami są firmy zarejestrowane w Polsce. Dzięki Usłudze Limit dostaniesz środki od Smart Faktora od razu po zgłoszeniu wierzytelności do wykupu, Faktor przelewa pieniądze na Twoje konto nawet tego samego dnia i cierpliwie czeka na zapłatę przedmiotowej faktury przez Twojego klienta w umówionym terminie.
				</div>
				<div className='w-full flex items-center justify-end'><LinkItem to={routes.LIMIT_OFFER} /></div>
			</Button>
		</div>
	);
}
